export const MY_STUDY_GROUPS_DEFAULT_PER_PAGE = 50;
export const MY_STUDY_GROUPS_STALE_TIME_MS = 3 * 60 * 1000;

const STUDY_GROUP_MEMBERSHIPS_ROOT = ["studyGroupMemberships"] as const;
const STUDY_GROUP_ADMINS_ROOT = ["studyGroupAdmins"] as const;
const STUDY_GROUP_YOUR_MEMBERSHIP_ROOT = ["studyGroupYourMembership"] as const;
const INVITABLE_USERS_ROOT = ["invitableUsers"] as const;
const MENTION_AVAILABLE_USERS_ROOT = ["studyGroupMentionUsers"] as const;
const INVITE_USERS_POLICY_ROOT = ["studyGroupInviteUsersPolicy"] as const;

export const studyGroupKeys = {
  membershipsRoot: STUDY_GROUP_MEMBERSHIPS_ROOT,
  memberships: (params: {
    studyGroupId: string | number | null;
    page: number;
    perPage: number;
    keyword?: string;
    membershipStatus?: number;
  }) =>
    [
      ...STUDY_GROUP_MEMBERSHIPS_ROOT,
      params.studyGroupId,
      params.page,
      params.perPage,
      params.keyword ?? "",
      params.membershipStatus ?? null,
    ] as const,
  adminsRoot: STUDY_GROUP_ADMINS_ROOT,
  admins: (params: {
    studyGroupId: string | number | null;
    page: number;
    perPage: number;
  }) =>
    [
      ...STUDY_GROUP_ADMINS_ROOT,
      params.studyGroupId,
      params.page,
      params.perPage,
    ] as const,
  yourMembershipRoot: STUDY_GROUP_YOUR_MEMBERSHIP_ROOT,
  yourMembership: (studyGroupId: string | number | null) =>
    [...STUDY_GROUP_YOUR_MEMBERSHIP_ROOT, studyGroupId] as const,
  invitableUsersRoot: INVITABLE_USERS_ROOT,
  invitableUsersByStudyGroup: (studyGroupId: string | number | null) =>
    [...INVITABLE_USERS_ROOT, studyGroupId] as const,
  invitableUsers: (studyGroupId: string | number | null, keyword?: string) =>
    [...INVITABLE_USERS_ROOT, studyGroupId, keyword ?? ""] as const,
  mentionAvailableUsersRoot: MENTION_AVAILABLE_USERS_ROOT,
  mentionAvailableUsersByStudyGroup: (studyGroupId: string | number | null) =>
    [...MENTION_AVAILABLE_USERS_ROOT, studyGroupId] as const,
  mentionAvailableUsers: (
    studyGroupId: string | number | null,
    keyword?: string,
  ) => [...MENTION_AVAILABLE_USERS_ROOT, studyGroupId, keyword ?? ""] as const,
  inviteUsersPolicy: (studyGroupId: string | number | null) =>
    [...INVITE_USERS_POLICY_ROOT, studyGroupId] as const,
  myStudyGroupsRoot: ["myStudyGroups"] as const,
  myStudyGroupsPage: (params: {
    page: number;
    perPage: number;
    status?: string;
  }) => ["myStudyGroups", params] as const,
  myStudyGroupsUnreadTotals: () => ["myStudyGroups", "unreadTotals"] as const,
  myStudyGroupsUnreadBadge: (studyGroupId: number) =>
    ["myStudyGroups", "unread", studyGroupId] as const,
  isMyStudyGroupsPageKey: (queryKey: readonly unknown[]): boolean => {
    if (!Array.isArray(queryKey) || queryKey.length < 2) return false;
    if (queryKey[0] !== "myStudyGroups") return false;
    const second = queryKey[1];
    return (
      typeof second === "object" &&
      second !== null &&
      "page" in second &&
      "perPage" in second
    );
  },
  isMembershipsKey: (queryKey: readonly unknown[]): boolean => {
    return (
      Array.isArray(queryKey) && queryKey[0] === STUDY_GROUP_MEMBERSHIPS_ROOT[0]
    );
  },
  isAdminsKey: (queryKey: readonly unknown[]): boolean => {
    return (
      Array.isArray(queryKey) && queryKey[0] === STUDY_GROUP_ADMINS_ROOT[0]
    );
  },
  isYourMembershipKey: (queryKey: readonly unknown[]): boolean => {
    return (
      Array.isArray(queryKey) &&
      queryKey[0] === STUDY_GROUP_YOUR_MEMBERSHIP_ROOT[0]
    );
  },
  isInviteUsersPolicyKey: (queryKey: readonly unknown[]): boolean => {
    return (
      Array.isArray(queryKey) && queryKey[0] === INVITE_USERS_POLICY_ROOT[0]
    );
  },
  isMyStudyGroupsKey: (queryKey: readonly unknown[]): boolean => {
    return Array.isArray(queryKey) && queryKey[0] === "myStudyGroups";
  },
};
